<template>
  <div class="daySign-div">
    <div class="home-swipe">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in swipeImg1" :key="index">
          <img :src="item.img" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div>
      <div class="home-article-nav">
        <ul>
          <li
            v-for="(item,index) in liList"
            :key="index"
            :class="isLink==index ? 'li-style li-check-style' : 'li-style'"
            @click="chooseLi(item,index)"
          >{{item.name}}</li>
        </ul>
      </div>
      <div class="day-sign-img">
        <!-- 热门推荐 -->
        <div class="daysign-right">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              :offset="1"
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div class="list-img">
                <div v-for="(v,i) in personList" :key="i" class="show-pop list-img-w">
                  <div ref="canvasImgUrl" class="canvas-img">
                    <van-image lazy-load @click="drawPost(v,i)" :src="getSrc(v)">
                      <div class="pop-style" v-if="isShowUser">
                        <div class="item-center">
                          <div class="user-info">
                            <div style="font-size: 8px">{{userInfo.realName}}</div>
                            <div style="font-size: 8px">{{userInfo.phone}}</div>
                          </div>
                          <qrcode :staffId="id" :avatarName="userInfo.avatarName"></qrcode>
                        </div>
                      </div>
                    </van-image>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </div>
    <van-popup v-model="show" :overlay="false" @close="closePop" closeable>
      <div class="pop-title">长按图片保存</div>
      <img class="save-img" :src="showImg" alt />
    </van-popup>
  </div>
</template>

<script>
import URL from "@/api/api";
import { Toast, Lazyload } from "vant";
import "swiper/swiper-bundle.min.css";
import qrcode from './moreQrcode.vue';
import html2canvas from 'html2canvas'
// import { TextBounds } from 'html2canvas/dist/types/css/layout/text';
export default {
  components: { qrcode },
  data() {
    return {
      swipeImg1: [
        { img: require('./img/day-banner.png') },
        { img: require('./img/day-banner.png') },
      ],
      chooseType: null,
      isLink: '0',
      liList: [
        { id: 1, name: '热门推荐', type: null, hot: 1 },
        { id: 2, name: '正能量', type: 2, hot: null },
        { id: 3, name: '节日', type: 3, hot: null },
        { id: 4, name: '早安', type: 4, hot: null },
        { id: 5, name: '晚安', type: 5, hot: null },
      ],

      // 
      userInfo: {},
      showImg: null,
      id: null,
      isShowUser: false,
      hotImg: true,//true为热门推荐
      personList: [],
      loading: false,
      finished: false,
      refreshing: false,
      show: false,
      pageNum: 1, //页数
      size: 5,//总条数
      total: 0
    }
  },
  // activated() {
  //   this.onLoad()
  // },
  created() {
    this.getstaff()
  },
  methods: {


    //判断展示的照片属性
    getSrc(item) {
      let url = item.url || item.imageUrl
      return process.env.VUE_APP_IMGURL + url   
    },
    // 关闭弹层
    closePop() {
      this.isShowUser = false
    },
    // 合成图片
    drawPost(v, e) {
      let that = this
      that.show = true
      that.isShowUser = true
      that.showImg = process.env.VUE_APP_IMGURL + (v.url || v.imageUrl)
      Toast.loading({
        message: '加载中...',
        forbidClick: true, // 禁止背景点击
        duration: 0 // 持续展示
      })
      var opts = {
        useCORS: true, // 【重要】开启跨域配置
        allowTaint: true,
        scrollY: 0, // 纵向偏移量 写死0 可以避免滚动造成偶尔偏移的现象
        scrollX: 0,
        height: that.$refs.canvasImgUrl[e].offsetHeight,
        width: that.$refs.canvasImgUrl[e].offsetWidth,
        scale: 8,
        dpi: window.devicePixelRatio * 2,
        backgroundColor: null
      };
      setTimeout(() => {
        html2canvas(that.$refs.canvasImgUrl[e], opts).then(canvas => {
          that.showImg = canvas.toDataURL("image/jpeg",1.0);
          Toast.clear()
        });
      }, 700)
    },
    // 获取staffid
    getstaff() {
      this.userid = localStorage.getItem("userid")
      this.$fetchGet(URL.getStaffsCard.url, { userId: this.userid }).then((res) => {
        (res);
        if (res.data.code === 20000) {
          this.id = res.data.data.id
          this.userInfo = res.data.data
        }
      })
    },
    getData(type, hot) {
      let that = this
      let data = {
        page: that.pageNum,
        size: that.size,
        companyCode: 'ZFKJ',
        picType: type,
        hotFlag: hot
      }
      this.$fetchGet(URL.posterImage.url, data).then((res) => {
        if (res.data.code === 20000) {
          let list = res.data.data.records; //请求返回当页的列表
          that.refreshing = false;
          that.loading = false;
          Toast.clear()
          that.total = res.data.data.total;
          if (list == null || list.length === 0) {
            // 加载结束
            that.finished = true;
            return;
          }
          // 将新数据与老数据进行合并
          if (that.pageNum > 1) {
            that.personList = [...that.personList, ...list]
          } else {
            that.personList = list
          }
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (that.personList.length >= that.total) {
            that.finished = true;
          }
          // 如果总页数大于当前页码，页码+1
          if (that.size * that.pageNum < that.total) {
            that.pageNum++;
          }
        }
      });
    },
    chooseLi(item, index) {
      this.isLink = index
      this.chooseType = item.type
      this.pageNum = 1
      this.finished = false;
      this.loading = true;
      if (!item.type) {
        this.hotImg = true
      } else {
        this.hotImg = false
      }
      this.getData(item.type, item.hot)
    },
    onRefresh() {
      this.finished = false;
      this.pageNum = 1
      this.loading = true;
      let hot = null;
      //热门推荐
      if (this.hotImg) {
        hot = 1
      }
      this.getData(this.chooseType, hot);
    },
    //触底回调函数(页面刷新由于finished为false 触发了触底回调)
    onLoad() {
      //热门推荐
      if (this.hotImg) {
        this.getData(null, 1);
      } else {
        this.getData(this.chooseType, null);
      }
    }
  }
}
</script>

<style lang="less" scoped>
.daySign-div {
  width: 100%;
  background: #fff;
  .home-swipe {
    width: 345px;
    height: 100px;
    margin: auto;
    img {
      width: 345px;
      height: 100px;
    }
  }
  .home-article-nav {
    width: 345px;
    margin: 15px auto 0 auto;
    list-style: none;
    ul {
      margin-top: 14px;
      display: flex;
      font-size: 11px;
      justify-content: space-between;
    }
    .li-style {
      width: 60px;
      height: 23.5px;
      line-height: 26px;
      text-align: center;
      background: url("./img/day-bg.png") no-repeat 100%;
      background-size: 100% 100%;
      font-size: 10.5px;
      font-family: PingFang SC;
      font-weight: Medium;
      color: #333333;
    }
    .li-check-style {
      background: url("./img/day-bg.png") no-repeat 100%;
      background-size: 100% 100%;
      color: #fc6e09;
    }
  }
  .day-sign-img {
    width: 345px;
    height: calc(100vh - 150px);
    margin: 9.5px auto 0;
    overflow: scroll;
    .van-image {
      width: 100%;
      height: 100%;
    }
    .canvas-img {
      width: 110px;
      height: 185px;
      background: transparent;
    }
    .list-img-w:nth-child(n) {
      margin-right: 7.5px;
      margin-top: 8px;
    }
    .list-img-w:nth-child(3n) {
      margin-right: 0;
    }
  }
}
//
.item-content,
.title-name {
  font-size: 0.4rem;
}
.list-img {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
}
// .list-img-w {
//   width: calc(50% - 0.1rem);
//   margin-right: 0.1rem;
// }
.daysign-con {
  display: flex;
  .daysign-left {
    width: 25%;
  }
  .daysign-right {
    width: 75%;
    padding: 0.12rem 0.12rem 0 0;
  }
}
.show-pop {
  position: relative;
}
.van-image {
  /deep/ .pop-style {
    height: 1.1rem;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    bottom: 0.1rem;
    width: 95%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 5px;
    .item-center {
      height: 1.1rem;
      display: flex;
      justify-content: space-around;
      align-items: center;
      justify-items: center;
      .user-info {
        color: #fff;
        // font-size: 8px;
        line-height: 1.2;
      }
    }
  }
}

.van-popup {
  width: 95%;
  height: 100%;
  img {
    width: 85%;
    display: block;
    margin: auto;
  }
}
.pop-title {
  height: 65px;
  font-size: 14px;
  text-align: center;
  line-height: 60px;
}
</style>